/** @format */

import { Injectable } from "@angular/core";
import { NsEmpWebExpData } from "../models/emp-web-exp.model";
import { NsWISConfigurations } from "../models/configurations.model";
import { EmpUserService } from "./emp-user.service";
import { BehaviorSubject, Subject } from "rxjs";
import { ActivatedRoute } from "@angular/router";

@Injectable({
  providedIn: "root"
})
export class SeatService {
  private sourceUrl = "";
  private source$ = new BehaviorSubject<string>("");
  source = this.source$.asObservable();
  private seatChange$ = new BehaviorSubject<NsEmpWebExpData.ISeatData>(null);
  seatChange = this.seatChange$.asObservable();
  private officeChange$ = new Subject<NsEmpWebExpData.ISeatChange>();
  officeChange = this.officeChange$.asObservable();
  mapChangedOffice = false;
  temperarySeat = new Subject<NsEmpWebExpData.ISeatData>();

  constructor(private userSvc: EmpUserService, private route: ActivatedRoute) {}

  setSeatMapSource(configs: NsWISConfigurations.IFlattenedSettings) {
    this.sourceUrl = configs?.employeeFloorPlanUrl || this.userSvc.environment.floorplan;
  }

  openMap(
    office: NsEmpWebExpData.IOffice,
    start: number,
    end: number,
    seat?: NsEmpWebExpData.ISeatData,
    colleague?: NsEmpWebExpData.INearbyBooking
  ): void {
    let url = "";
    if (start === -1 || end === -1) {
      url = "";
    } else {
      const token = this.route.snapshot.queryParamMap.get("auth-token");
      url = `${this.sourceUrl}?openedFrom=web&startTime=${start}&endTime=${end}&empGuid=${this.userSvc.employeeInfo.empGuid}&buid=${
        this.userSvc.employeeInfo.buid
      }&officeGuid=${office.value}&search=${this.mapChangedOffice}${token ? `&auth-token=${token}` : ""}`;
      if (seat?.floorId && seat?.seatId) {
        url += `&floorId=${seat.floorId}&seatId=${seat.seatId}`;
      } else if (colleague?.floorId) {
        url += `&floorId=${colleague.floorId}&teammateGuid=${colleague.teamMateEmpGuid}`;
      }
    }
    this.source$.next("");
    setTimeout(() => {
      this.source$.next(url);
    }, 10);
  }

  changeSeat(seat: NsEmpWebExpData.ISeatData): void {
    this.seatChange$.next(seat);
  }

  changeOffice(info: NsEmpWebExpData.ISeatChange): void {
    this.officeChange$.next(info);
  }
}
